// extracted by mini-css-extract-plugin
export default {"itemsContainer":"XfaTemplateElementNode_itemsContainer__ER9oS"};